// Kies-/Schüttgut-Rechner: reine Logik. Fläche × Schütthöhe → Volumen, Gewicht, Big Bags.
// Schüttdichten (lose) in Tonnen/m³, verifiziert gegen Baustoff-/Garten-Quellen.
export const MATERIALIEN = {
  schotter: { label: "Schotter", dichte: 1.6 },
  kies: { label: "Kies", dichte: 1.6 },
  splitt: { label: "Splitt", dichte: 1.5 },
  zierkies: { label: "Zierkies", dichte: 1.6 },
  sand: { label: "Sand", dichte: 1.5 },
  basaltsplitt: { label: "Basaltsplitt", dichte: 1.7 },
  betonkies: { label: "Betonkies", dichte: 1.7 },
};

export const MATERIAL_KEYS = Object.keys(MATERIALIEN);

const num = (v) => (Number(v) || 0);
function round(v, n = 2) {
  if (!isFinite(v)) return 0;
  const f = 10 ** n;
  return Math.round(v * f) / f;
}

// laenge/breite in Metern, hoehe (Schütthöhe) in cm.
export function schuettgut(material, { laenge, breite, hoehe } = {}) {
  const m = MATERIALIEN[material];
  if (!m) throw new Error(`Unbekanntes Material: ${material}`);
  const flaeche = num(laenge) * num(breite); // m²
  const volumen = flaeche * (num(hoehe) / 100); // m³
  const gewichtTonnen = volumen * m.dichte;
  return {
    material,
    dichte: m.dichte,
    flaeche: round(flaeche),
    volumen: round(volumen, 3),
    gewichtTonnen: round(gewichtTonnen, 2),
    gewichtKg: Math.round(gewichtTonnen * 1000),
    // Big Bags sind gewichts-limitiert: 1-Tonnen-Sack, daher aus dem Gewicht.
    bigbags: Math.max(0, Math.ceil(gewichtTonnen)),
  };
}
